<template>
  <vx-card class="mt-2 card-impressao pagebreak-inside-avoid">
    <table class="table card-impressao table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="4">CORRETORA</th>
      </tr>
      <tr>
        <td class="pl-3" colspan="2">
          <b>Corretora:</b>
          {{ broker.corporateReason || proposalData.regional }}
        </td>
        <td class="pl-3" colspan="2">
          <b>CNPJ/CPF:</b> {{ proposalData.regionalCnpj }}
        </td>
      </tr>
      <tr>
        <td class="pl-3" colspan="2">
          <b>SUSEP:</b> {{ proposalData.regionalSusep }}
        </td>
        <td class="pl-3" colspan="1">
          <b>Cidade:</b> {{ proposalData.regionalCidade }}
        </td>
        <td class="pl-3" colspan="1">
          <b>UF:</b> {{ proposalData.regionalEstado }}
        </td>
      </tr>
      <tr>
        <td class="pl-3" colspan="2">
          <b>Telefone:</b> {{ broker.phoneNumber }}
        </td>
        <td class="pl-3" colspan="1"><b>Email:</b> {{ broker.email }}</td>
      </tr>
    </table>

    <div
      v-if="customSectionsMsgs.BROKER_DATA"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.BROKER_DATA"
    ></div>
  </vx-card>
</template>

<script>
export default {
  name: 'EndorsementContractBroker',
  props: {
    broker: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>
